import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/8a5a49b2ff6dd887c77db8ea2694b0c6.jpg"
        alt="Luxury cabin in the Blue Ridge Mountains, Highlands NC"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55" />

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-6">
        <p className="text-[#C9A96E] text-xs tracking-[0.35em] uppercase font-jost font-light mb-6 animate-fade-in">
          Your Trusted Cabin Guide &bull; Highlands, North Carolina
        </p>
        <h1 className="font-cormorant text-white text-6xl md:text-7xl lg:text-8xl font-light leading-none tracking-tight mb-6 max-w-5xl">
          Best Cabins in<br />
          <em className="italic font-light">Highlands, North Carolina</em>
        </h1>
        <p className="text-white/80 font-jost text-lg font-light leading-relaxed max-w-2xl mb-4">
          A curated guide to the best places to stay in Highlands, NC — from luxury cabins in Highlands, North Carolina to cozy retreats near waterfalls, hiking trails, and downtown.
        </p>
        <p className="text-white/65 font-jost text-sm font-light leading-relaxed max-w-xl mb-10">
          Top picks include <strong className="text-white/85 font-medium">Glen Falls Luxury Cabin in Highlands, NC</strong> and other highly rated stays near scenic waterfalls and the Blue Ridge Mountains.
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/best-luxury-cabins"
            className="bg-white text-[#2D4A3E] text-xs tracking-[0.2em] uppercase font-jost font-medium px-10 py-4 rounded-full hover:bg-[#F5F1EB] transition-colors cursor-pointer whitespace-nowrap"
          >
            Browse Top Cabins
          </Link>
          <Link
            to="/cabins-in-highlands-nc"
            className="border border-white/60 text-white text-xs tracking-[0.2em] uppercase font-jost font-medium px-10 py-4 rounded-full hover:border-white hover:bg-white/10 transition-all cursor-pointer whitespace-nowrap"
          >
            Cabins in Highlands, NC
          </Link>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2">
        <span className="text-white/40 text-xs tracking-widest uppercase font-jost">Scroll</span>
        <div className="w-px h-10 bg-white/30 animate-pulse" />
      </div>
    </section>
  );
}